import { type CustomerDisplayConnectionOptions } from 'washday-sdk';
import WashdayClientSingleton from './WashdayClientSingleton';

export const connectCustomerDisplay = (options: Omit<CustomerDisplayConnectionOptions, 'baseUrl' | 'token'>) =>
  WashdayClientSingleton.getInstance().customerDisplay.connectPublisher(options);
